<template>
    <div class="upload-landlord-sign">
        <cropper v-model="croppedImg" :imageType="files.length?'FILE':'BASE64'" :image="files.length?files[0].blob:landlordInfo.signatureBase64" />
        <div class="image-cover">
            <div v-if="files.length == 0 && !landlordInfo.signatureBase64" class="cover-block">
                <file-upload
                class="upload-btn"
                post-action="/upload/post"
                input-id="files"
                :size="1024 * 5"
                :maximum="1"
                :multiple="true"
                v-model="files"
                @input-file="inputFile"
                @input-filter="inputFilter"
                ref="uploadCover">
                    <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                    上傳圖片
                </file-upload>
                <!-- <span v-show="imgCoverError" class="error">必填欄位</span> -->
            </div>
            <div v-else  class="cover-preview">
                <div @mouseenter="isHover=true" @mouseleave="isHover=false">
                    <div v-show="isHover" @click="cropperImg()" class="full-screen">
                        <img src="@/assets/img/icon/fullscreen.svg" alt="">
                    </div>
                    <div class="preview">
                        <img v-if="croppedImg" :src="croppedImg" />
                        <img v-else-if="files.length" :src="files[0].blob" />
                        <img v-else :src="'data:image/png;base64,'+landlordInfo.signatureBase64" />
                    </div>
                </div>
                <file-upload
                    class="replace"
                    post-action="/upload/post"
                    input-id="files"
                    :size="1024 * 5"
                    :maximum="1"
                    :multiple="true"
                    :drop="true"
                    :drop-directory="true"
                    v-model="files"
                    @input-file="inputFile"
                    @input-filter="inputFilter"
                    ref="uploadCover">
                        取代圖片
                </file-upload>
            </div>
        </div>
    </div>
</template>
<script>
import cropper from '@/components/bussiness/widges/modals/cropper.vue';
import FileUpload from 'vue-upload-component';
import constant from '@/constant'
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            files: [],
            croppedImg: null,
            isHover: false
        }
    },
    watch: {
        files: function (val){
            let reader = new FileReader();
            reader.readAsDataURL(val[0].file)
            setTimeout(()=>{
                this.$store.dispatch('setBizLandlordSignature', reader.result)
            }, 300)
        },
        croppedImg: function (val){
            this.$store.dispatch('setBizLandlordSignature', val)
        },
    },
    destroyed(){
        this.files = []
        this.croppedImg = null   
    },
    methods: {
        cropperImg: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizCropper'})
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
        
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.error = '請上傳JPG或PNG檔案'
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        imageUrl: function (url){
            return constant.imageUrlNoCdn+url
        },
    },
    computed: {
        ...mapGetters({
            landlordInfo: 'GET_BIZ_LANDLORD_INFO',
        })
    },
    components: {
        FileUpload,
        cropper
    }
}
</script>
<style lang="scss" scoped>
.upload-landlord-sign {
    .image-cover{
        margin-bottom: 30px;
        .cover-block{
            position: relative;
            width: 124px;
            height: 93px;
            border-radius: 4px;
            border: dashed 1px #cacfcd;
            background-color: #ffffff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img{
                width: 24px;
                margin-bottom: 4px;
            }
            .upload-btn{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
            .error{
                position: absolute;
                width: 200px;
                left: 136px;
                font-weight: 500;
                font-size: 12px;
                color:  #F05A3E;
                top: unset;
            }
        }
        .cover-block.error{
            border: dashed 1px #F05A3E;
        }
        .cover-preview{
            display: flex;
            align-items: center;
            .full-screen{
                position: absolute;
                width: 124px;
                height: 93px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                background-color: rgba(32, 35, 34, 0.8);
                cursor: pointer;
            }
            .preview{
                width: 124px;
                height: 93px;
                display: flex;
                margin-right: 16px;
                align-items: center;
                border-radius: 4px;
                overflow: hidden;
                >img{
                    width: 100%;
                }
            }
            .replace{
                width: 104px;
                height: 44px;
                border-radius: 4px;
                border: solid 1px #e0dfde;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/landlordMgt/uploadLandlordSign.vue